import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageConfig,
} from '../pages/configs';

const RouteConfigs = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageConfig />
      </Route>
    </Switch>
  );
};

export default RouteConfigs;
